"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeResult = exports.deserialize = void 0;
var cloud_elementory_protocol_1 = require("@wix/cloud-elementory-protocol");
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
var isSerializedError = function (result) { return !!(result === null || result === void 0 ? void 0 : result._elementoryError); };
var convertToErrorObject = function (result) {
    var err = new Error(result.message);
    err.stack = result.stack;
    err.name = result.name;
    err.code = result.code;
    return err;
};
var deserializeResult = function (result) {
    return isSerializedError(result) ? convertToErrorObject(result) : result;
};
exports.deserializeResult = deserializeResult;
var deserialize = function (text) {
    var _a = (0, cloud_elementory_protocol_1.convertFromCustomFormat)(JSON.parse(text)), result = _a.result, exception = _a.exception;
    return {
        isError: !!exception,
        payload: deserializeResult(result),
    };
};
exports.deserialize = deserialize;
//# sourceMappingURL=deserialize.js.map